import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';

export function registerLocationContentContainerResourceBundleEn(
  i18next: i18n
): void {
  i18next.addResourceBundle(
    'en',
    'record-it-components',
    {
      location: {
        LocationContentContainer: {
          noPermissionMessage: 'Access to the location data was denied.',
          unavailableMessage: 'Location data is currently not available.'
        }
      }
    } as Partial<CustomTypeOptions['resources']['record-it-components']>,
    true
  );
}
